// material-ui
import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import {
  Box,
  Button,
  Stack,
  Popper,
  IconButton,
  List,
  ListItemButton,
  Paper,
  ListItemText,
  Typography,
  Divider,
  ClickAwayListener
} from '@mui/material';
import LogoSection from 'layout/MainLayout/LogoSection';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ThemeButton from 'ui-component/ThemeButton';
import ProfileSection from 'layout/MainLayout/Header/ProfileSection';
import { IconMenu2 } from '@tabler/icons-react';
import Transitions from 'ui-component/extended/Transitions';
import MainCard from 'ui-component/cards/MainCard';
import { useMediaQuery } from '@mui/material';
import {useEffect } from 'react';
// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
  const theme = useTheme();
  const { pathname } = useLocation();
  const account = useSelector((state) => state.account);
  const [open, setOpen] = useState(null);
  const [isAtTop, setIsAtTop] = useState(true);
  const [activeSection, setActiveSection] = useState(null);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // 添加滚动监听
  useEffect(() => {
    const handleScroll = () => {
      setIsAtTop(window.scrollY === 0);
      
      // 检测当前滚动到的区域
      const featuresSection = document.getElementById('features-section');
      const wdSection = document.getElementById('features-section1');
      
      const scrollPosition = window.scrollY + 100; // 添加偏移量
      
      if (featuresSection && scrollPosition >= featuresSection.offsetTop && 
          (!wdSection || scrollPosition < wdSection.offsetTop)) {
        setActiveSection('features');
      } else if (wdSection && scrollPosition >= wdSection.offsetTop) {
        setActiveSection('wd');
      } else {
        setActiveSection(null);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleOpenMenu = (event) => {
    setOpen(open ? null : event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  return (
    <>
      <Box
        sx={{
          width: 228,
          display: 'flex',
          marginLeft: -17,
          [theme.breakpoints.down('md')]: {
            width: 'auto',
            marginLeft: -1
          }
        }}
      >
        <Box component="span" sx={{ flexGrow: 1 }}>
          <LogoSection />
        </Box>
        <Button 
          component={Link} 
          variant="text" 
          to="/" 
          color={pathname === '/' && isAtTop ? 'primary' : 'inherit'}
          sx={{ fontSize: '20px', marginLeft: '50px' ,
            '&:hover': {
              color: 'primary.main',
              backgroundColor: 'white',
            }}}
          onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}
        >
          首页
        </Button>
        <Button 
        component={Link}
          variant="text" 
            to="/"
          color={activeSection === 'features' ? 'primary' : 'inherit'}
          onClick={() => {
            const section = document.getElementById('features-section');
            if (section) {
              const yOffset = -80;
              const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
              window.scrollTo({top: y, behavior: 'smooth'});
            }
          }}
          sx={{ 
            fontSize: '20px',
            marginLeft:'80px',
            whiteSpace: 'nowrap',
            '&:hover': {
              color: 'primary.main',
              backgroundColor: 'white',
            }
          }}  // 添加字体大小设置和悬浮效果

        >
          如何使用
        </Button>
        <Button
          component={Link}
          variant="text" 
            to="/"
          color={activeSection === 'wd' ? 'primary' : 'inherit'}
          onClick={() => {
            const section = document.getElementById('features-section1');
            if (section) {
              const yOffset = -80;
              const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
              window.scrollTo({top: y, behavior: 'smooth'});
            }
          }}
          sx={{ fontSize: '20px',marginLeft:'80px',whiteSpace: 'nowrap' ,
            '&:hover': {
              color: 'primary.main',
              backgroundColor: 'white',
            } }}  // 添加字体大小设置
        >
          最新功能
        </Button>
        {/* <Button variant="text" 
            component={Link}
            to="/"
          color={pathname === '/1' ? 'primary' : 'inherit'}
          onClick={() => {
            const section = document.getElementById('features-section');
            if (section) {
              const yOffset = -80; // 调整这个值来匹配导航栏高度
              const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
              window.scrollTo({top: y, behavior: 'smooth'});
            }
          }}
          sx={{ fontSize: '18px',marginLeft:'20px' }}  // 添加字体大小设置

        >
              价格
        </Button> */}

        {/* <Button variant="text" 
          // component={Link}
          // to="/apidocx/clothes"  // 直接指定跳转路径
          // color={pathname === '/apidocx/clothes' ? 'primary' : 'inherit'}
          // sx={{ fontSize: '18px', marginLeft: '20px' }}
          component="a"
          href="https://www.qihuaimage.com/chat"
          target="_blank"
          rel="noopener noreferrer"
          color={pathname === '/apidocx/clothes' ? 'primary' : 'inherit'}
          sx={{ fontSize: '20px', marginLeft: '80px',whiteSpace: 'nowrap',
            '&:hover': {
              color: 'primary.main',
              backgroundColor: 'white',
            } }}
        >
              直连站公测
        </Button> */}

        {/* 奇画无限画布按钮 - 仅登录后显示 */}
        {/* {account.user && (
          <Button variant="text" 
            component={Link}
            to="/canvas"  // 跳转到canvas页面
            color={pathname === '/canvas' ? 'primary' : 'inherit'}
            sx={{ fontSize: '20px', marginLeft: '80px',whiteSpace: 'nowrap',
              '&:hover': {
                color: 'primary.main',
                backgroundColor: 'white',
              } }}
          >
                奇画无限画布
          </Button>
        )} */}
        {/* <Typography
          sx={{ 
            mt: 1.4,
            height: '24px',
            fontSize: '14px', 
            marginLeft: '28px',
            whiteSpace: 'nowrap',
            background: 'linear-gradient(90deg, #2196F3, #9C27B0, #E91E63)',
            color: 'white',
            userSelect: 'none',
            pointerEvents: 'none',
            marginRight: '42px',
            padding: '2px 6px',
            borderRadius: '34px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          注册送积分
        </Typography> */}
      </Box>

      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />
      <Stack spacing={2} direction="row" justifyContent="center" alignItems="center" sx={{
          // width: 228,
          // marginLeft: -17, // 添加负左边距，让组件离左边更近，数值可按需调整
          marginRight: -17, // 添加负右边距，让组件离右边更近，数值可按需调整
        }}>
        {isMobile ? (
          <>
            <ThemeButton />
            <IconButton onClick={handleOpenMenu}>
              <IconMenu2 />
            </IconButton>
          </>
        ) : (
          <>
            {/* <Button component={Link} variant="text" to="/" color={pathname === '/' ? 'primary' : 'inherit'}>
              首页
            </Button>
            <Button component={Link} variant="text" to="/about" color={pathname === '/about' ? 'primary' : 'inherit'}>
              关于
            </Button> */}
            {/* <ThemeButton /> */}
            {account.user ? (
              <>
                <Button component={Link} variant="contained" to="/panel" color="primary">
                  控制台
                </Button>
                <ProfileSection />
              </>
            ) : (
              <Button component={Link} variant="contained" to="/login" color="primary">
                登录
              </Button>
            )}
          </>
        )}
      </Stack>

      <Popper
        open={!!open}
        anchorEl={open}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 14]
              }
            }
          ]
        }}
        style={{ width: '100vw' }}
      >
        {({ TransitionProps }) => (
          <Transitions in={open} {...TransitionProps}>
            <ClickAwayListener onClickAway={handleCloseMenu}>
              <Paper style={{ width: '100%' }}>
                <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                  <List
                    component="nav"
                    sx={{
                      width: '100%',
                      maxWidth: '100%',
                      minWidth: '100%',
                      backgroundColor: theme.palette.background.paper,

                      '& .MuiListItemButton-root': {
                        mt: 0.5
                      }
                    }}
                    onClick={handleCloseMenu}
                  >
                    <ListItemButton component={Link} variant="text" to="/">
                      <ListItemText primary={<Typography variant="body2">首页</Typography>} />
                    </ListItemButton>

                    <ListItemButton component={Link} variant="text" to="/about">
                      <ListItemText primary={<Typography variant="body2">关于</Typography>} />
                    </ListItemButton>
                    <Divider />
                    {account.user ? (
                      <ListItemButton component={Link} variant="contained" to="/panel" color="primary">
                        控制台
                      </ListItemButton>
                    ) : (
                      <ListItemButton component={Link} variant="contained" to="/login" color="primary">
                        登录
                      </ListItemButton>
                    )}
                  </List>
                </MainCard>
              </Paper>
            </ClickAwayListener>
          </Transitions>
        )}
      </Popper>
    </>
  );
};

export default Header;
